import { PasswordRequirementsResponseDto, RequirementDto } from './types';
import { GET_PASSWORD_REQUIREMENTS_QUERY_KEY } from './utils';
import { useApiQuery } from '../../utils';

export interface UsePasswordRequirementQueryResult {
  requirements?: RequirementDto[];
  isLoadingPasswordRequirements: boolean;
  isFetchingPasswordRequirements: boolean;
}

export const usePasswordRequirementsQuery = (
  password: string,
  userName?: string,
  organizationId?: number,
  baseUrl?: string
): UsePasswordRequirementQueryResult => {
  const {
    data: requirements,
    isLoading: isLoadingPasswordRequirements,
    isFetching: isFetchingPasswordRequirements,
  } = useApiQuery<PasswordRequirementsResponseDto>({
    queryKey: GET_PASSWORD_REQUIREMENTS_QUERY_KEY,
    config: { baseURL: '/' },
    endpoint: `${baseUrl}/v2/self_service/password_requirements`,
    params: {
      password: password,
      user_name: userName,
      organization_id: organizationId,
    },
  });
  return {
    requirements: requirements?.data,
    isLoadingPasswordRequirements,
    isFetchingPasswordRequirements,
  };
};
